import React, { useState } from "react";
import { TextField, MenuItem, Button } from "@mui/material";
import MainCalculatorsList from "./MainCalculators";
import RelatedLinks from "../RelatedLinks";
import { SecondAds,   FirstAds , MobileUnderCalAds } from "../../Ads";
import SharedHelmet from "../Helmet";
import * as yup from "yup";
import { Field, Form, Formik } from "formik";
const TITLE = "حاسبة قوة حصان المحرك - احسب قوة محرك السيارة";
const DESCRIPTION =
  "حاسبة قوة حصان المحرك: قم بحساب قوة محرك سيارتك أو دراجتك النارية بدقة! أدخل العزم (نيوتن متر) وعدد الدورات (RPM) لتحصل على قوة الحصان الفعلية (HP) فوراً - مع تفسير النتائج!";
const KEYWORDS =
  "حاسبة قوة حصان المحرك، حساب الحصان، تقدير قوة المركبة، القوة المحركة، أداء السيارة";
const OG_URL = "https://do-calculate.com/calculator/ar/horsepower";
const weightConversionMap = {
  pound: 1,
  ton: 2204.6226218,
  kg: 2.2046226218,
};
const timeConversionMap = {
  second: 1,
  minute: 60,
  hour: 3600,
  day: 3600 * 24,
};
const speedConversionMap = {
  "miles per hour": 1,
  "kilometers per hour": 0.6213711922,
  "meters per second": 2.236936,
};
const ETSchema = yup.object().shape({
  vehicleWeight: yup
    .number()
    .typeError("تأكد من القيمة بأن تكون عدد")
    .required("تأكد من ادخال قيمة")
    .max(1000000000, "الرقم كبير جدا")
    .min(0, "تأكد من عدم ادخال قيم سالبة"),
  ET: yup
    .number()
    .typeError("تأكد من القيمة بأن تكون عدد")
    .required("تأكد من ادخال قيمة")
    .max(1000000000, "الرقم كبير جدا")
    .min(0, "تأكد من عدم ادخال قيم سالبة"),
});
const initialETValues = {
  vehicleWeight: "",
  ET: "",
  vehicleWeightUnit: "pound",
  ETUnit: "second",
};
const TSSchema = yup.object().shape({
  vehicleWeight: yup
    .number()
    .typeError("تأكد من القيمة بأن تكون عدد")
    .required("تأكد من ادخال قيمة")
    .max(1000000000, "الرقم كبير جدا")
    .min(0, "تأكد من عدم ادخال قيم سالبة"),
  TS: yup
    .number()
    .typeError("تأكد من القيمة بأن تكون عدد")
    .required("تأكد من ادخال قيمة")
    .max(1000000000, "الرقم كبير جدا")
    .min(0, "تأكد من عدم ادخال قيم سالبة"),
});
const initialTSValues = {
  vehicleWeight: "",
  TS: "",
  vehicleWeightUnit: "pound",
  TSUnit: "miles per hour",
};
function EngineHorsepower() {
  const [horsepowerET, setHorsepowerET] = useState("");
  const onSubmitET = (values) => {
    const { vehicleWeight, ET, vehicleWeightUnit, ETUnit } = values;
    const ConversionWeight =
      vehicleWeight * weightConversionMap[vehicleWeightUnit];
    const ConversionET = ET * timeConversionMap[ETUnit];
    const factor = Math.pow(ConversionET / 5.825, 3);
    const horsepowerET = ConversionWeight / factor;
    setHorsepowerET(horsepowerET.toFixed(2));
  };
  const [horsepowerTS, setHorsepowerTS] = useState("");
  const onSubmitTS = (values) => {
    const { vehicleWeight, TS, vehicleWeightUnit, TSUnit } = values;
    const ConversionWeight =
      vehicleWeight * weightConversionMap[vehicleWeightUnit];
    const ConversionTS = TS * speedConversionMap[TSUnit];
    const factor = Math.pow(ConversionTS / 234, 3);
    const horsepowerTS = ConversionWeight * factor;
    setHorsepowerTS(horsepowerTS.toFixed(3));
  };
  return (
    <div className="rtl">
      <SharedHelmet
        TITLE={TITLE}
        DESCRIPTION={DESCRIPTION}
        KEYWORDS={KEYWORDS}
        OG_URL={OG_URL}
      />
      <div className="row">
        <div className="col-12 col-md-8">
          <FirstAds />
        </div>
      </div>
      <div className="row">
        <div className="col-12 col-md-8">
          <br />
          <div
            className="bg-success text-white text-center"
            style={{ height: "50px" }}
          >
            <h1 style={{ fontSize: "17px" }}>{TITLE}</h1>
          </div>
          <div className="border border-light">
            <div className="row">
              <div>
                <p>
                  مرحبًا بك في حاسبة قوة حصان المحرك، الأداة الفعّالة التي
                  تساعدك في حساب وتقدير قوة محرك سيارتك بكل سهولة. سواء كنت
                  تعتني بأداء سيارتك الحالية أو تفكر في شراء سيارة جديدة، يمكن
                  لهذه الحاسبة أن تقدم لك إحصائيات دقيقة حول القوة الحصانية
                  للمحرك.
                </p>
                <h2 style={{ fontSize: "17px" }}>كيفية استخدام الحاسبة:</h2>
                <p>
                  استخدام حاسبتنا بسيط جدا. قم بإدخال المعلومات الرئيسية حول
                  محرك سيارتك، مثل عدد الأسطوانات، وحجم الإزاحة، وعزم الدوران.
                  بمجرد إدخال هذه البيانات، ستحسب الحاسبة تلقائياً قوة المحرك
                  بالحصان.
                </p>
                <h2 style={{ fontSize: "17px" }}>
                  فوائد حاسبة قوة حصان المحرك:
                </h2>
                <ul>
                  <li>تقديم تقدير دقيق لأداء المحرك.</li>
                  <li>فهم أفضل لقوة السيارة وكفاءتها.</li>
                  <li>مساعدة في اتخاذ قرارات أفضل عند شراء سيارة جديدة.</li>
                </ul>
                <p>
                  احصل على معلومات دقيقة ومفيدة حول قوة محرك سيارتك الآن. قم
                  بزيارة حاسبة قوة حصان المحرك واحسب الأداء بسهولة ويسر!
                </p>
                <p>
                  يمكن استخدام الحاسبتين التاليتين لتقدير القدرة الحصانية لمحرك
                  السيارة بناءً على وزن السيارة والوقت المنقضي والسرعة المستخدمة
                  لإنهاء مسافة ربع ميل. يجب أن يشمل وزن السيارة ليس فقط السيارة،
                  ولكن أيضًا السائق والراكب وأي شيء آخر له وزن كبير. لتقدير
                  القدرة الحصانية القصوى، يجب تطبيق الحد الأقصى لإخراج العمل من
                  البداية إلى النهاية. نتائج جميع الحسابات هي تقديرات فقط.
                  <br />
                  <b>طريقة الوقت المنقضي (ET):</b> تستخدم هذه الطريقة وزن
                  السيارة والوقت المنقضي (ET) لإنهاء مسافة ربع ميل (402.3 متر)
                  حسب الصيغة التالية : <br />
                  الوزن / (ET/5.825)^3 <br />
                  <b>طريقة فخ السرعة:</b> تستخدم هذه الطريقة وزن المركبة والسرعة
                  التي قطعت بها المركبة مسافة ربع ميل (402.3 متر) حسب الصيغة
                  التالية : <br />
                  الوزن * (السرعة / 234)^3 <br /> يجب أن تكون السرعة المستخدمة
                  هي السرعة التي تم الوصول إليها عند نقطة الربع ميل، وليس السرعة
                  المتوسطة.
                </p>
                <hr />
              </div>
              <br />
            </div>
            <MobileUnderCalAds />
            <div className="row">
              <div className="col-sm-12 col-md-7 calculatorStyle">
                <Formik
                  initialValues={initialETValues}
                  validationSchema={ETSchema}
                  onSubmit={onSubmitET}
                >
                  {(formik) => (
                    <Form>
                      <div className="mb-3">
                        <h3
                          className="p-3 mb-2 bg-success text-white"
                          style={{ fontSize: "16px", fontWeight: "bold" }}
                        >
                          طريقة الوقت المنقضي (ET):
                        </h3>
                        <TextField
                          label="وزن السيارة"
                          name="vehicleWeight"
                          value={formik.values.vehicleWeight}
                          onChange={formik.handleChange}
                          onBlur={formik.handleBlur}
                          error={
                            formik.touched.vehicleWeight &&
                            formik.errors.vehicleWeight
                          }
                          helperText={
                            formik.touched.vehicleWeight &&
                            formik.errors.vehicleWeight
                          }
                          sx={{
                            width: "160px",
                            ml: "10px",
                            bgcolor: "#f9f9f9",
                            "&  .MuiFormHelperText-root.Mui-error": {
                              backgroundColor: "rgb(229, 230, 227) !important",
                              margin: 0,
                              padding: "8px 0 0 41px",
                            },
                          }}
                          size="small"
                          color="success"
                        />
                        <Field
                          as={TextField}
                          select
                          name="vehicleWeightUnit"
                          value={formik.values.vehicleWeightUnit}
                          onChange={formik.handleChange}
                          size="small"
                          style={{
                            backgroundColor: "#f9f9f9",
                            pending: "5px",
                          }}
                        >
                          {Object.keys(weightConversionMap).map((unit) => (
                            <MenuItem key={unit} value={unit}>
                              {unit}
                            </MenuItem>
                          ))}
                        </Field>
                      </div>
                      <div className="mb-3">
                        <TextField
                          label="الوقت لإنهاء ربع ميل"
                          name="ET"
                          value={formik.values.ET}
                          onChange={formik.handleChange}
                          onBlur={formik.handleBlur}
                          error={formik.touched.ET && formik.errors.ET}
                          helperText={formik.touched.ET && formik.errors.ET}
                          sx={{
                            width: "160px",
                            ml: "10px",
                            bgcolor: "#f9f9f9",
                            "&  .MuiFormHelperText-root.Mui-error": {
                              backgroundColor: "rgb(229, 230, 227) !important",
                              margin: 0,
                              padding: "8px 0 0 41px",
                            },
                          }}
                          size="small"
                          color="success"
                        />
                        <Field
                          as={TextField}
                          select
                          name="ETUnit"
                          value={formik.values.ETUnit}
                          onChange={formik.handleChange}
                          size="small"
                          style={{
                            backgroundColor: "#f9f9f9",
                            pending: "5px",
                          }}
                        >
                          {Object.keys(timeConversionMap).map((unit) => (
                            <MenuItem key={unit} value={unit}>
                              {unit}
                            </MenuItem>
                          ))}
                        </Field>
                      </div>
                      <div className="mb-3">
                        <Button
                          type="submit"
                          disabled={!formik.isValid}
                          color="success"
                          sx={{
                            backgroundColor: "rgb(25,135,84)",
                            fontSize: "15px",
                            marginRight: "25px",
                            padding: "5px 25px",
                            color: "white",
                          }}
                        >
                          إحسب
                        </Button>
                        <Button
                          disabled={!formik.isValid}
                          sx={{
                            backgroundColor: "rgb(108,117,125)",
                            fontSize: "15px",
                            marginRight: "25px",
                            padding: "5px 25px",
                            color: "white",
                          }}
                          onClick={() => {
                            formik.resetForm();
                            setHorsepowerET("");
                          }}
                        >
                          امسح النتيجة
                        </Button>
                      </div>
                      {horsepowerET &&
                        horsepowerET !== "NaN" &&
                        horsepowerET !== "Infinity" && (
                          <div
                            style={{ fontSize: "15px" }}
                            className=" bg-light  text-dark"
                          >
                            <div className="p-3 bg-success text-white mb-2">
                              <strong>
                                النتيجة: قوة المحرك المقدرة: {horsepowerET}{" "}
                                Horsepower{" "}
                              </strong>
                            </div>
                          </div>
                        )}
                    </Form>
                  )}
                </Formik>
              </div>
            </div>
            <hr />
            <div className="row">
              <div className="col-sm-12 col-md-7 calculatorStyle">
                <Formik
                  initialValues={initialTSValues}
                  validationSchema={TSSchema}
                  onSubmit={onSubmitTS}
                >
                  {(formik) => (
                    <Form>
                      <div className="mb-3">
                        <h3
                          className="p-3 mb-2 bg-success text-white"
                          style={{ fontSize: "16px", fontWeight: "bold" }}
                        >
                          طريقة فخ السرعة:
                        </h3>
                        <TextField
                          label="وزن السيارة"
                          name="vehicleWeight"
                          value={formik.values.vehicleWeight}
                          onChange={formik.handleChange}
                          onBlur={formik.handleBlur}
                          error={
                            formik.touched.vehicleWeight &&
                            formik.errors.vehicleWeight
                          }
                          helperText={
                            formik.touched.vehicleWeight &&
                            formik.errors.vehicleWeight
                          }
                          sx={{
                            width: "160px",
                            ml: "10px",
                            bgcolor: "#f9f9f9",
                            "&  .MuiFormHelperText-root.Mui-error": {
                              backgroundColor: "rgb(229, 230, 227) !important",
                              margin: 0,
                              padding: "8px 0 0 41px",
                            },
                          }}
                          size="small"
                          color="success"
                        />
                        <Field
                          as={TextField}
                          select
                          name="vehicleWeightUnit"
                          value={formik.values.vehicleWeightUnit}
                          onChange={formik.handleChange}
                          size="small"
                          style={{
                            backgroundColor: "#f9f9f9",
                            pending: "5px",
                          }}
                        >
                          {Object.keys(weightConversionMap).map((unit) => (
                            <MenuItem key={unit} value={unit}>
                              {unit}
                            </MenuItem>
                          ))}
                        </Field>
                      </div>
                      <div className="mb-3">
                        <TextField
                          label="السرعة عند الانتهاء من ربع ميل"
                          name="TS"
                          value={formik.values.TS}
                          onChange={formik.handleChange}
                          onBlur={formik.handleBlur}
                          error={formik.touched.TS && formik.errors.TS}
                          helperText={formik.touched.TS && formik.errors.TS}
                          sx={{
                            width: "160px",
                            ml: "10px",
                            bgcolor: "#f9f9f9",
                            "&  .MuiFormHelperText-root.Mui-error": {
                              backgroundColor: "rgb(229, 230, 227) !important",
                              margin: 0,
                              padding: "8px 0 0 41px",
                            },
                          }}
                          size="small"
                          color="success"
                        />
                        <Field
                          as={TextField}
                          select
                          name="TSUnit"
                          value={formik.values.TSUnit}
                          onChange={formik.handleChange}
                          size="small"
                          style={{
                            backgroundColor: "#f9f9f9",
                            pending: "5px",
                          }}
                        >
                          {Object.keys(speedConversionMap).map((unit) => (
                            <MenuItem key={unit} value={unit}>
                              {unit}
                            </MenuItem>
                          ))}
                        </Field>
                      </div>
                      <div className="mb-3">
                        <Button
                          type="submit"
                          disabled={!formik.isValid}
                          color="success"
                          sx={{
                            backgroundColor: "rgb(25,135,84)",
                            fontSize: "15px",
                            marginRight: "25px",
                            padding: "5px 25px",
                            color: "white",
                          }}
                        >
                          إحسب
                        </Button>
                        <Button
                          disabled={!formik.isValid}
                          sx={{
                            backgroundColor: "rgb(108,117,125)",
                            fontSize: "15px",
                            marginRight: "25px",
                            padding: "5px 25px",
                            color: "white",
                          }}
                          onClick={() => {
                            formik.resetForm();
                            setHorsepowerTS("");
                          }}
                        >
                          امسح النتيجة
                        </Button>
                      </div>
                      {horsepowerTS &&
                        horsepowerTS !== "NaN" &&
                        horsepowerTS !== "Infinity" && (
                          <div
                            style={{ fontSize: "15px" }}
                            className=" bg-light  text-dark"
                          >
                            <div className="p-3 bg-success text-white mb-2">
                              <strong>
                                النتيجة: قوة المحرك المقدرة: {horsepowerTS}{" "}
                                Horsepower{" "}
                              </strong>
                            </div>
                          </div>
                        )}
                    </Form>
                  )}
                </Formik>
              </div>
            </div>
            <hr />
            <hr />
            <div className="row">
              <RelatedLinks />
              <hr />
            </div>
          </div>
        </div>
        <div className="col">
          <SecondAds />
          <br />
          <MainCalculatorsList></MainCalculatorsList>
          <br />
        </div>
      </div>
      <div className="row" style={{ height: "auto" }}>
        <div className="col-12 col-md-8">
          <div className="info-sections-container">
            <div className="info-section">
              <div className="info-section-header">
                كل ما تحتاج لمعرفته حول قوة محرك السيارة (القدرة الحصانية) :
              </div>
              <div className="info-section-body">
                <u>
                  <h2 style={{ fontSize: "16px" }}> الاحتياطات الخاصة :</h2>
                </u>
                <br />
                <p>
                  عند قياس الوقت المنقضي أو سرعة المصيدة عند أقصى خرج عمل
                  للمحرك، يجب اتخاذ احتياطات خاصة: <br />
                  أولاً، يحتاج جميع السائقين إلى معرفة ما يفعلونه بالضبط. يمكن
                  أن تؤدي قلة الخبرة إلى تداعيات قد يكون بعضها خطيرًا ويهدد
                  الحياة. <br /> ثانيًا، لا تقيس الوقت المنقضي على مسافة ربع ميل
                  في الشوارع العامة أو الطرق السريعة؛ إن القيادة بتجاوز الحد
                  الأقصى للسرعة أمر غير قانوني ويجب أن يركز انتباه السائق على
                  القيادة وليس على قياس الوقت. هذه الأنشطة يمكن أن تعرض للخطر
                  ليس السائق فحسب، بل الأشخاص الآخرين أيضًا. هناك أماكن قانونية
                  لقياس الوقت المنقضي، مثل شرائط السحب، والطرق الريفية المملوكة
                  للقطاع الخاص، وأثناء المناسبات الخاصة التي تقام في المجاري
                  المائية أو المطارات.
                  <br /> ثالثاً، التأكد من أن السيارة في حالة عمل كاملة، حيث أن
                  أخذ السيارة إلى أقصى حدودها ينطوي على مخاطر معينة. تأكد من أن
                  الإطارات منتفخة بشكل صحيح ومؤمنة بشكل سليم، وأن الوسائد
                  الهوائية تعمل، وأن المحرك مضبوط بشكل صحيح وفي حالة جيدة.
                </p>
                <hr />
                <u>
                  <h2 style={{ fontSize: "16px" }}>ما هي القدرة الحصانية؟</h2>
                </u>
                <br />
                <p>
                  فكرة القدرة الحصانية ابتكرها مهندس القرن التاسع عشر جيمس وات،
                  الذي قام ببناء بعض المحركات البخارية الأولى. كان عمل وات
                  رائعًا، وتكريمًا له، أطلق اسمه على وحدة القدرة، الواط (لا، لم
                  يخترع المصباح الكهربائي، لكن اسمه موجود على كل مصباح). كان وات
                  يعمل في منجم، مستخدمًا الخيول لسحب عربات الفحم. لقد أراد تحديد
                  كمية الفحم التي يمكن لمهر أن يسحبها في عربة بطول معين. قام
                  بقياس عدد الأقدام التي يستطيع الحصان سحب 22000 رطل من الفحم في
                  دقيقة واحدة. ثم زاد ذلك المقدار إلى 33 ألف رطل في الدقيقة،
                  وسماه القدرة الحصانية. إنها كمية اعتباطية تمامًا، ولكنها أصبحت
                  مقياسًا لمقدار العمل الذي يمكن لمحركات العمل القيام به، ولم
                  يقم أحد بقياس ذلك من قبل. لذا، تخيل حصانًا يسحب عربة من الفحم
                  من منجم؛ بجهد قدره حصان واحد، يسحب الحصان 330 رطلاً من الفحم
                  لمسافة 100 قدم في دقيقة واحدة.
                </p>
                <hr />
                <u>
                  <h2 style={{ fontSize: "16px" }}>قياس القدرة الحصانية :</h2>
                </u>
                <br />
                <p>
                  يتم قياس القدرة الحصانية بواسطة مقياس القوة. يتطلب الأمر قدرًا
                  معينًا من الطاقة لجعل الدوار يدور بسرعة معينة. إذا قمت بوضع
                  سيارة في الوضع المحايد، ثم قمت بتثبيت المحرك على الأرض أثناء
                  توصيله بمقياس ديناميكي، فإن الجهاز يضع حملاً على المحرك ويرى
                  ما إذا كان يمكنه تحويل الحمل أو مدى السرعة التي يمكنه بها
                  تحويل الحمل. إذا قمت بتشغيل المحرك بسرعة 5000 دورة في الدقيقة
                  (دورة في الدقيقة)، فسترى مقدار الحمل الذي يتم تشغيله على مقياس
                  القوة لحساب القدرة الحصانية. يتمتع كل محرك بقدرة حصانية قصوى -
                  وهي قيمة دورة في الدقيقة تكون عندها الطاقة المتاحة من المحرك
                  عند الحد الأقصى. غالبًا ما ترى هذا معبرًا عنه في كتيب أو
                  مراجعة في إحدى المجلات باسم "320 حصانًا عند 6500 دورة في
                  الدقيقة".
                </p>
                <hr />
                <u>
                  <h2 style={{ fontSize: "16px" }}>
                    القدرة الحصانية الإجمالية أو الصافية :
                  </h2>
                </u>
                <br />
                <p>
                  القوة الحصانية الإجمالية هي مقياس لإخراج العمل لمحرك فقط على
                  مباشرة القياس، عندما لا يكون المحرك متصلاً بالملحقات المعتادة
                  الموجودة في سيارة تعمل. تقيس القوة الحصانية الصافية إخراج
                  المحرك عندما يكون متصلاً بملحقات تعمل بواسطة السير مثل مضخات
                  المياه ومضخات توجيه القوة والمولدات الكهربائية. هناك أيضًا
                  خسائر فاعلة في القوة الناتجة عن سحب النقل وانزلاق القابض أو
                  المحول القابل للانزلاق التي تأخذ القوة الحصانية الصافية في
                  الاعتبار. نتيجة لتشغيل هذه الأجزاء المتحركة، يمكن أن تكون
                  القوة الحصانية الصافية أقل بكثير من القوة الحصانية الإجمالية.
                </p>
                <hr />
                <u>
                  <h2 style={{ fontSize: "16px" }}>
                    قوة حصان مقابل عزم الدوران :
                  </h2>
                </u>
                <br />
                <p>
                  العزم يعرف كقوة دوران. يتم قياسه كمية القوة المضروبة في طول
                  العتلة التي يتم من خلالها العمل. على سبيل المثال، إذا استخدمت
                  مفتاحًا بطول قدم واحدة لتطبيق 10 رطل من القوة على رأس البرغي،
                  فأنت تولد 10 رطل قدم من العزم. يجب ملاحظة أن العزم يتم قياسه
                  بالرطل القدم، والقوة الحصانية تقاس بالأقدام الرطل في الثانية.
                  العزم هو القوة التي يمكن تطبيقها لدفع المركبة إلى الأمام. في
                  حالة وزن المركبة المعطى، فإن العزم العالي يعني أن المركبة
                  يمكنها التسارع بشكل أسرع وأكثر استجابة. على الرغم من أن هذا
                  ليس صحيحًا دائمًا، عمومًا، كلما زاد العزم الذي يتولده المحرك،
                  زادت قدرته على القيام بعمل أكبر. بالمثل، فإن المحرك الذي ينتج
                  قوة حصان أكبر عمومًا لديه القدرة على توليد عزم أعلى. لفهم
                  العلاقة بين القوة الحصانية والعزم بشكل أوضح، فكر في الفرق بين
                  سيارة سباق وجرار. السيارة السباقية خفيفة الوزن، وبالتالي فإن
                  مستوى القوة الحصانية العالية يمرر العزم من خلال نظام التروس
                  لجعلها تسير بسرعة. من ناحية أخرى، الجرار هو آلة ضخمة ثقيلة
                  مصممة للقيام بالعمل. الجرار لا يمكنه الذهاب بسرعة، ولكن نظام
                  التروس الخاص به يطبق العزم بحيث يمكنه الدفع والجر. إذا وضعت
                  نفس المحرك ذو القوة الحصانية العالية على سيارة سباق وجرار، فإن
                  النتيجة ستكون سيارة سباق سريعة، ولكنها ليست مركبة قادرة على
                  تحطيم جدار من الخرسانة. الجرار البطيء يطبق عمله على الضغط على
                  الجدار ويكسره. لهذا السبب، عندما تبحث عن مواصفات سيارة في مجلة
                  السيارات، ستجد مؤشرات لكل من القوة الحصانية والعزم.
                </p>
                <hr />
                <u>
                  <h2 style={{ fontSize: "16px" }}>القوة الحصانية والأداء :</h2>
                </u>
                <br />
                <p>
                  ما نسميه السيارة "عالية الأداء" هي مجرد سيارة ذات قوة حصانية
                  كبيرة ووزن منخفض؛ تعتبر نسبة القوة إلى الوزن العامل الأساسي في
                  تحديد السيارة عالية الأداء. ومن الأمثلة النموذجية على ذلك
                  سيارة فيراري، التي قد تتمتع بقوة 800 حصان على سيارة يبلغ وزنها
                  3500 رطل. وهذا يجعل نسبة القوة إلى الوزن حوالي 0.229.
                  وبالمقارنة، فإن سيارة فورد إكسبلورر، التي تباع بحوالي عُشر سعر
                  سيارة فيراري، قد تمتلك حوالي 300 حصان لتتحرك حوالي 4500 جنيه.
                  نسبة القوة إلى الوزن أقل بكثير (حوالي 0.067). ستنتقل سيارة
                  فيراري من صفر إلى 60 ميلاً في الساعة أسرع بكثير من سيارة فورد
                  إكسبلورر.
                </p>
                <hr />
              </div>
            </div>
          </div>
        </div>
         </div>
</div>
  );
}
export default EngineHorsepower;
